import React, { createContext, useContext } from 'react';
import { useFitnetStatus } from '../hooks/useFitnetStatus';

const FitnetContext = createContext({ isAvailable: null, loading: true });

export function FitnetProvider({ children }) {
  const fitnetStatus = useFitnetStatus();
  
  return (
    <FitnetContext.Provider value={fitnetStatus}>
      {children}
    </FitnetContext.Provider>
  );
}

export function useFitnet() {
  return useContext(FitnetContext);
}

export default FitnetContext;
